// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  IconApps,
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconBuildingBank,
  IconSettings,
  IconSchool,
  IconUser,
  IconBell,
  IconCalendarEvent,
  IconMenu2,
  IconDatabase,
  IconCash,
  IconUsers,
  IconDeviceDesktopAnalytics,
} from "@tabler/icons";

// constant
const icons = {
  IconApps,
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconBuildingBank,
  IconSettings,
  IconSchool,
  IconUser,
  IconBell,
  IconCalendarEvent,
  IconMenu2,
  IconDatabase,
  IconCash,
  IconUsers,
  IconDeviceDesktopAnalytics,
};

const menus = {
  id: "application",
  icon: icons.IconApps,
  type: "group",
  children: [],
};

const LOCAL_TEST_BRAND = "entrarDemo";
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isLocalhost = hostname.includes("localhost");

let subdomain = isLocalhost
  ? LOCAL_TEST_BRAND
  : hostname.split(".").length > 2
  ? hostname.split(".")[0]
  : "";

const checkInstitutionType =
  localStorage.getItem("institutionType") === "School";

const SuperAdminMenu = () => {
  const MenusData = [
    {
      id: "Dashboard",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",
      icon: icons.IconApps,
      url: "/dashboard/analytics",
      breadcrumbs: false,
      target: false,
      children: [],
    },
    {
      id: "Institute",
      title: <FormattedMessage id="Institute Registration" />,
      type: "item",
      icon: icons.IconBuildingBank,
      url: "/institute",
      breadcrumbs: false,
      target: false,
      children: [],
    },
    {
      id: "Menu Setup",
      title: <FormattedMessage id="Menu Setup" />,
      type: "collapse",
      icon: icons.IconMenu2,
      children: [
        {
          id: "Module",
          title: <FormattedMessage id="Module" />,
          type: "item",
          url: "/module/list",
        },
        {
          id: "Menu Permission",
          title: <FormattedMessage id="Menu Permission" />,
          type: "item",
          url: "/menu/permission/list",
        },
        {
          id: "Report Reason Setup ",
          title: <FormattedMessage id="Report Reason Setup" />,
          type: "item",
          url: "/report-master",
        },
      ],
    },
  ];
  menus.children = MenusData;
};

const StaticMenus = () => {
  const MenusData = [
    {
      id: "Dashboard",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",
      icon: icons.IconApps,
      url: "/institute/dashboard",
      breadcrumbs: false,
      target: false,
      children: [],
    },
    {
      id: "Alumni",
      title: <FormattedMessage id="Alumni" />,
      type: "collapse",
      icon: icons.IconUsers,
      breadcrumbs: false,
      children: [
        {
          id: "PendingApplication",
          title: <FormattedMessage id="Pending Applications" />,
          type: "item",
          url: "/pending/application",
        },
        {
          id: "PendingSocialPost",
          title: <FormattedMessage id="Pending Post" />,
          type: "item",
          url: "/pending/post",
        },
        {
          id: "PendingVideos",
          title: <FormattedMessage id="Video Post" />,
          type: "item",
          url: "/pending/alumni-videos",
        },
        {
          id: "AIApprovedPost",
          title: <FormattedMessage id="AI Approved Post" />,
          type: "item",
          url: "/ai/approved/post",
        },
        {
          id: "AlumniDirectory",
          title: <FormattedMessage id="Alumni Directory" />,
          type: "item",
          url: "/alumni/register",
        },
        {
          id: "AlumniGroup",
          title: <FormattedMessage id="Alumni Group" />,
          type: "item",
          url: "/groups",
        },
        {
          id: "PendingStarAlumni",
          title: <FormattedMessage id="Pending Star-Alumni" />,
          type: "item",
          url: "/pending/star-alumni",
        },
        {
          id: "RaisedIssues",
          title: <FormattedMessage id="Help Requests" />,
          type: "item",
          url: "/raised-issues",
        },
        {
          id: "Mentor-Mentee",
          title: <FormattedMessage id="Mentor-Mentee Report" />,
          type: "item",
          url: "/mentor-mentee/report",
        },
      ],
    },
    {
      id: "Event",
      title: <FormattedMessage id="Event" />,
      type: "collapse",
      icon: icons.IconCalendarEvent,
      children: [
        {
          id: "Event List",
          title: <FormattedMessage id="Event List" />,
          type: "item",
          url: "/createvent",
        },
        {
          id: "Event Approvals",
          title: <FormattedMessage id="Event Approval" />,
          type: "item",
          url: "/approvals",
        },
        {
          id: "EventType",
          title: <FormattedMessage id="Event Type" />,
          type: "item",
          url: "/eventType/list",
        },
        {
          id: "EventBadge",
          title: <FormattedMessage id="Event Badge" />,
          type: "item",
          url: "/event/badge",
        },
      ],
    },
    {
      id: "Announcements",
      title: <FormattedMessage id="Announcement" />,
      type: "collapse",
      icon: icons.IconBell,
      children: [
        {
          id: "Announcements",
          title: <FormattedMessage id="Announcements" />,
          type: "item",
          url: "/announcements",
        },
        {
          id: "Notifications",
          title: <FormattedMessage id="Notifications" />,
          type: "item",
          url: "/additional/notification",
        },
      ],
    },
    {
      id: "Users",
      title: <FormattedMessage id="Users" />,
      type: "item",
      icon: icons.IconUser,
      url: "/user/list",
      breadcrumbs: false,
      target: false,
      children: [],
    },
    {
      id: "Master Setup",
      title: <FormattedMessage id="Master Setup" />,
      type: "collapse",
      icon: icons.IconDatabase,
      children: [
        {
          id: checkInstitutionType ? "Standard" : "Program",
          title: (
            <FormattedMessage
              id={checkInstitutionType ? "Standard" : "Program"}
            />
          ),
          type: "item",
          url: "/program/list",
        },
        {
          id: "Batch",
          title: <FormattedMessage id="Batch" />,
          type: "item",
          url: "/batch/list",
        },
        {
          id: "Branch",
          title: <FormattedMessage id="Branch" />,
          type: "item",
          url: "/branch/list",
        },
        {
          id: "Industries",
          title: <FormattedMessage id="Industries" />,
          type: "item",
          url: "/industries/list",
        },
        {
          id: "Functional Area",
          title: <FormattedMessage id="Functional Area" />,
          type: "item",
          url: "/functional-area/list",
        },
        {
          id: "Video Category",
          title: <FormattedMessage id="Video Category" />,
          type: "item",
          url: "/video-category/list",
        },
      ],
    },
    {
      id: "Fee Setup",
      title: <FormattedMessage id="Fee Setup" />,
      type: "collapse",
      icon: icons.IconCash,
      children: [
        {
          id: "Fee Head",
          title: <FormattedMessage id="Fee Head" />,
          type: "item",
          url: "/fee-head",
        },
        {
          id: "Fee Mapping",
          title: <FormattedMessage id="Fee Mapping" />,
          type: "item",
          url: "/fee-mappings",
        },
      ],
    },
    {
      id: "Reports",
      title: <FormattedMessage id="Reports" />,
      type: "collapse",
      icon: icons.IconDeviceDesktopAnalytics,
      children: [
        {
          id: "Transactions",
          title: <FormattedMessage id="Transactions" />,
          type: "item",
          url: "/reports/payments-info",
        },
      ],
    },
    {
      id: "Settings",
      title: <FormattedMessage id="Settings" />,
      type: "item",
      icon: icons.IconSettings,
      url: "/setting",
      breadcrumbs: false,
      target: false,
      children: [],
    },
  ];
  menus.children = MenusData;
};

const AlumniMenus = () => {
  // future logic for ROLE_ALUMNI if needed
};

const role = localStorage.getItem("role");

if (role === "ROLE_SUPER_ADMIN") {
  SuperAdminMenu();
} else if (
  role === "ROLE_COLLEGE_ADMIN" ||
  role === "ROLE_SUB_ADMIN" ||
  role === "ROLE_COLLEGE_SUB_ADMIN"
) {
  StaticMenus();
} else if (role === "ROLE_ALUMNI") {
  AlumniMenus();
} else {
  console.log("Unknown role:", role);
}

export default menus;
